import lists from "./lists.css";

function Lists () {
    return (
        <div id="Lists">
            <div>
                <ul>
                    <li>
                        <div className="lists">
                            <img src="./assets/images/icon-list.svg" alt="icon list"/>
                            <p>Product discovery and building what matters</p>
                        </div>
                        
                    </li>
                    <li>
                        <div className="lists">
                            <img src="./assets/images/icon-list.svg" alt="icon list"/>
                            <p>Measuring to ensure updates are a success</p>
                        </div>
                        
                    </li>
                    <li>
                        <div className="lists">
                            <img src="./assets/images/icon-list.svg" alt="icon list"/>
                            <p>And much more!</p>
                        </div>
                        
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default Lists;